export const RoomStatusEnum = {
  OPEN: 'OPEN', // 開放中
  CLOSE: 'CLOSE', // 未開放
  RESERVE: 'RESERVE', // 保留中
  BOOKING: 'BOOKING', // 已預約
}
